import React from 'react';
import {
    Text,
} from '@chakra-ui/react';

export function TextoInicioCalculadora(){

    return(
        <>
            <Text ml={2}>
                Algunas calculadoras para tener a mano
            </Text>
        </>
    )
}
